export interface IIdsErrorDescription {
    code: number | IdsErrorCode;
    httpStatus: number;
    description: string;
    alert: {
        de: string;
    };
}

export const IDS_EXCEPTION = "ids-error" as const;

export interface IIdsExceptionResponse extends IIdsErrorDescription {
    error: typeof IDS_EXCEPTION;
    success: false;
}

export class IdsException extends Error {
    public readonly type = "IdsError";

    constructor(public readonly code: IdsErrorCode | number) {
        super();
    }
}

export enum IdsErrorCode {
    INVALID_CLIENT_ID = 1000,
    UNKNOWN_CLIENT = 1001,
    ACCOUNT_NOT_VERIFIED = 1002,
    INTERNAL_SERVER_ERROR = 1003,
    INVALID_CREDENTIALS = 1004,
    ACCOUNT_LOCKED = 1005,
    EMAIL_EXISTS = 1006,
    UNKNOWN_USER = 1007,
    INVITATION_DECLINED = 1008,
    INVITATION_ALREADY_ACCEPTED = 1009,
    INSUFFICIENT_PERMISSIONS = 1010,
    ROLE_EXISTS = 1011,
    ROLE_NOT_EXISTS = 1012,
    INVITATION_EXPIRED = 1013,
    GOOGLE_ACCOUNT_REQUIRED = 1014,
    GOOGLE_PROFILE_IMAGE_REQUIRED = 1015,
    CLIENT_REQUIRED_ROLES_MISSING = 1016,
    INVITATION_INVALID = 1017,
    GOOGLE_EMAIL_MISMATCH = 1018,
    GOOGLE_LINK_REQUIRES_SESSION = 1019,
    FILE_TOO_LARGE = 4000,
    INVALID_FILE_TYPE = 4001,
    FILE_PROCESSING_ERROR = 4002
}
